var _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_653)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21_653",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#F6F6F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21_653)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 69.5,
    fill: "#F6F6F6",
    stroke: "#0270B2",
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.0661 88.9336C90.9261 90.6516 89.3281 92.0336 87.4481 92.9256H90.7521C91.9941 92.9256 92.998 91.9256 92.998 90.6896C93 89.9536 92.6261 89.3296 92.0661 88.9336Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.442 89.4277H71.4281C69.6301 89.4277 68.1681 87.9697 68.1681 86.1756V78.9376C68.1681 77.1436 69.6281 75.6817 71.4281 75.6817H73.6401C74.2081 74.9637 74.8581 74.3157 75.5821 73.7517H67.5401C66.8681 73.7517 66.3241 73.2097 66.3241 72.5397V69.0437C66.3241 68.3757 66.8681 67.8317 67.5401 67.8317H82.4561C83.1281 67.8317 83.6701 68.3737 83.6701 69.0437V71.3957C85.1241 71.5337 86.4941 71.9517 87.7401 72.5857V60.2817C87.7401 56.8737 86.5721 56.9976 86.5721 56.9976C85.9281 56.9976 85.4041 57.5177 85.4041 58.1637V64.3277C84.9541 62.8477 84.0961 61.2517 83.1041 61.2517H66.8921C65.8961 61.2517 65.0381 62.8496 64.5861 64.3296V58.1637C64.5861 57.5197 64.0641 56.9976 63.4181 56.9976C63.4181 56.9976 62.2521 56.9977 62.2521 60.2817V79.1377H61.3C59.838 79.1377 58.6521 80.3197 58.6521 81.7757V88.4537C58.6521 88.4957 58.6721 88.5276 58.6741 88.5676C57.7181 88.8216 56.998 89.6536 56.998 90.6876C56.998 91.9236 58.0001 92.9237 59.2401 92.9237H77.6981C76.0081 92.1217 74.548 90.9157 73.442 89.4277ZM63.882 87.9936C62.674 87.9936 61.692 87.0157 61.692 85.8057C61.692 84.6017 62.672 83.6236 63.882 83.6236C65.092 83.6236 66.0721 84.6017 66.0721 85.8057C66.0721 87.0157 65.092 87.9936 63.882 87.9936Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8244 78.486V72.374C80.6144 73.046 79.4384 75.28 78.8664 78.486H81.8244Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8244 92.9996V86.8896H78.8664C79.4384 90.0936 80.6144 92.3296 81.8244 92.9996Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5124 82.6884C78.5124 83.6384 78.5704 84.5424 78.6604 85.3964H81.8244V79.9844H78.6604C78.5704 80.8364 78.5124 81.7364 78.5124 82.6884Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8064 78.4865H92.1024C90.9104 75.8145 88.6304 73.7325 85.8164 72.8125C86.7304 74.1825 87.4264 76.1445 87.8064 78.4865Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6304 85.3945C92.8644 84.5285 93.0024 83.6245 93.0024 82.6865C93.0024 81.7505 92.8664 80.8465 92.6304 79.9805H88.0004C88.0864 80.8465 88.1324 81.7505 88.1324 82.6865C88.1324 83.6245 88.0864 84.5285 88.0004 85.3945H92.6304Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2824 78.486C85.7124 75.28 84.5364 73.046 83.3244 72.374V78.486H86.2824Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3444 86.8896H73.0464C74.2364 89.5616 76.5204 91.6436 79.3284 92.5616C78.4184 91.1916 77.7244 89.2316 77.3444 86.8896Z",
    fill: "#D9D9D9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8064 86.8896C87.4284 89.2316 86.7324 91.1896 85.8184 92.5616C88.6304 91.6436 90.9164 89.5616 92.1084 86.8896H87.8064Z",
    fill: "#D9D9D9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5204 79.9824C72.2864 80.8484 72.1504 81.7524 72.1504 82.6884C72.1504 83.6264 72.2844 84.5304 72.5204 85.3964H77.1484C77.0624 84.5304 77.0124 83.6264 77.0124 82.6884C77.0124 81.7524 77.0624 80.8484 77.1484 79.9824H72.5204Z",
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3444 78.4865C77.7224 76.1445 78.4184 74.1845 79.3284 72.8125C76.5204 73.7325 74.2364 75.8145 73.0484 78.4865H77.3444Z",
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6344 82.6884C86.6344 81.7364 86.5804 80.8364 86.4904 79.9824H83.3264V85.3944H86.4904C86.5784 84.5424 86.6344 83.6364 86.6344 82.6884Z",
    fill: "#D9D9D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3244 86.8896V92.9996C84.5344 92.3296 85.7104 90.0936 86.2824 86.8896H83.3244Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSelect);
export default __webpack_public_path__ + "static/media/profile-select.da3c23810fc9998f0878d1a9c4ba5305.svg";
export { ForwardRef as ReactComponent };